"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serviceUnavailableError = exports.internalServerError = exports.conflictError = exports.notFoundError = exports.forbiddenError = exports.unauthorizedError = void 0;
const unauthorizedError = (message) => ({
    statusCode: 401,
    error: 'Unauthorized',
    message,
});
exports.unauthorizedError = unauthorizedError;
const forbiddenError = (message) => ({
    statusCode: 403,
    error: 'Forbidden',
    message,
});
exports.forbiddenError = forbiddenError;
const notFoundError = (message) => ({
    statusCode: 404,
    error: 'Not Found',
    message,
});
exports.notFoundError = notFoundError;
const conflictError = (message) => ({
    statusCode: 409,
    error: 'Conflict',
    message,
});
exports.conflictError = conflictError;
const internalServerError = (message) => ({
    statusCode: 500,
    error: 'Internal Server Error',
    message,
});
exports.internalServerError = internalServerError;
const serviceUnavailableError = (message) => ({
    statusCode: 503,
    error: 'Service Unavailable',
    message,
});
exports.serviceUnavailableError = serviceUnavailableError;
//# sourceMappingURL=generators.js.map